import { helpers } from 'veritone-redux-common';
import { get } from 'lodash';

import { REMOVE_ADVERTISER } from './advertiser';
import { REMOVE_CAMPAIGN } from './campaign';
const { createReducer } = helpers;
export const GET_VISUAL_DATA_REFRESH_SAGA = "get visual data refresh saga";
export const GET_VISUAL_DATA_REFRESH = "get visual data refresh";
export const RE_PROCESS_SAGA = "re process saga";
export const REMOVE_VISUAL_REFRESH_DATA_SAGA = "remove visual refresh data saga";
const defaultState = {
    currentData: []
}

const visualDataRefreshReducer = createReducer(defaultState, {
    [GET_VISUAL_DATA_REFRESH]: (state, action) => {
        const { currentData } = action.payload;
        return {
            ...state,
            currentData: [...currentData],
        }
    },
    [REMOVE_ADVERTISER]: (state, action) => {
        const { advertiser } = action.payload;
        const advertiserId = get(advertiser, 'advertiser_id');
        
        const currentData = get(state, 'currentData', []);
        const newCurrentData = currentData.filter(item => (item && item.advertiser_id !== advertiserId));

        return {
            ...state,
            currentData: newCurrentData
        }
    },
    [REMOVE_CAMPAIGN]: (state, action) => {
        const { campaign } = action.payload;
        const campaignId = get(campaign, 'campaign_id');

        const currentData = get(state, 'currentData', []);
        const newCurrentData = currentData.filter(item => (item && item.campaign_id !== campaignId));
        return {
            ...state,
            currentData: newCurrentData
        }
    }
})

export const getVisualRefreshData = (currentData) => ({
    type: GET_VISUAL_DATA_REFRESH,
    payload: {
        currentData
    }
})

export const reProcessSaga = (queue) => ({
    type: RE_PROCESS_SAGA,
    payload: {
        queue
    }
})

export const removeVisualRefreshDataSaga = (queue) => ({
    type: REMOVE_VISUAL_REFRESH_DATA_SAGA,
    payload: {
        queue
    }
})

export const getVisualRefreshDataSaga = () => ({
    type: GET_VISUAL_DATA_REFRESH_SAGA
})

export const namespace = "visualDataRefresh"

export const selectVisualRefreshData = state => state[namespace];

export default visualDataRefreshReducer;
